module.exports = __webpack_public_path__ + "img/banner-5.d66c4bd9.jpg";